/**
 * @dreprecated use handleMessageMultipleChanges instead.
 */
export function handleMessageChange(
  field,
  newValue,
  nodes,
  setNodes,
  oldSelectedNode,
) {
  const selectedNode = oldSelectedNode ?? nodes.find((n) => n.selected);
  if (!selectedNode) {
    return;
  }
  setNodes((nds) =>
    nds.map((node) => {
      if (node.id === selectedNode.id) {
        // it's important that you create a new object here
        // in order to notify react flow about the change
        node.data = {
          ...node.data,
          [field]: newValue,
        };
      }
      return node;
    }),
  );
}
